import { Injectable } from "@angular/core";
import { errorMessages } from "../../settings";
import { CommonService } from "../common.service";
import { WidgethelperService } from "../widgethelper.service";
import { BaseService } from "./base.service";

@Injectable()
export class PendingWaveTasksService extends BaseService{

  constructor(
    private _commonService: CommonService,
    private _widgetHelper: WidgethelperService
  ) {
    super();
  }

  init(widget: any) {
    this._widgetHelper.CreateHub(widget)
    this.DisplayData(widget);
  }

  DisplayData(widget: any) {
    widget.hub.listenFor("BroadcastPendingWaveTasks").subscribe(
      (result: any) => {
        console.log("BroadcastPendingWaveTasks", result);
        let resultwid;
        let resultcreationtime;
        let lastUpdatedTime;

        if (result && result.length > 0) {
          //console.log(result[0].IsNoDataFound);
          widget.IfNoDataFound = result[0].IsNoDataFound;
          resultwid = result[0].widgetid;
          resultcreationtime = result[0].widgetcreationtime;
          lastUpdatedTime = result[0].LastUpdateTime;
        }
        else {
          widget.errorMessage = errorMessages.noWidgetData;
        }
        console.log("Result : ", result);
        if (resultwid == widget.widgetId && resultcreationtime == widget.widgetcreationtime) {
          widget.dataLoaded = false;
          widget.chartOptions = this.chartOptions();
          widget.errorMessage = null;
          if(widget.IfNoDataFound){
            widget.errorMessage = errorMessages.noWidgetData;
          }else if (widget.IfNoDataFound == null) {
            widget.errorMessage = "Retrieving records please wait.";
          }
          else{
            //Actual logic
             console.log('Retrieving records' , '1');
              let widget_Xaxis = [];
              let widget_Series1 = [];
              let widget_Series2 = [];
              for (let i = 0; i < result.length; i++) {
                  let pendingSummary: any = result[i];
                  widget_Xaxis.push(pendingSummary.WaveTitle +  "\n" + pendingSummary.WaveCode );
                   widget_Series1.push({
                    value: pendingSummary.PendingBatchTasks });
                   widget_Series2.push({
                    value: pendingSummary.PendingSortTasks });
              }
              this.addDataSeries(widget.chartOptions,[],'Batch Tasks', 'bar');
              this.addDataSeries(widget.chartOptions,[],'Sort Tasks', 'bar');

              widget.chartOptions.legend.data = ['Batch Tasks', 'Sort Tasks'];

              widget.chartOptions.series[0].data = widget_Series1;
              widget.chartOptions.series[1].data = widget_Series2;
              widget.chartOptions.xAxis.data = widget_Xaxis;
              widget.chartOptions.xAxis.type = 'category';
          }
        }
        widget.dataLoaded = true;
        this._commonService.lastUpdatedTime = lastUpdatedTime;

      },
      err => {
        console.log("listenFor BroadcastPendingWaveTasks error", err);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/widgets/pending-wave-tasks.service.ts